import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing-cta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative min-h-[80vh] flex items-center pt-16 pb-12 overflow-hidden bg-amber-50/50" data-id="element-125">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" data-id="element-126" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-127">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto" data-id="element-128">
          <div className="text-center lg:text-left" data-id="element-129">
            <FadeIn delay={0.1} data-id="element-130">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-900 mb-6" data-id="element-131">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse" data-id="element-132" />
                <span className="text-sm font-bold text-primary uppercase tracking-wider" data-id="element-133">
                  Para Profesionales del Fitness
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-134">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-gray-900" data-id="element-135">
                Cómo Justificar Cada Ejercicio con{' '}
                <span className="text-primary" data-id="element-136">Criterio Profesional Real</span>
                <br data-id="element-137" />
                <span className="whitespace-nowrap" data-id="element-138">en Segundos</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-139">
              <h2 className="text-xl md:text-2xl text-gray-500 font-medium max-w-2xl mx-auto lg:mx-0" data-id="element-140">
                Dejá de{' '}
                <span className="text-gray-800 font-semibold" data-id="element-141">improvisar</span>{' '}
                y trabajá con una{' '}
                <span className="text-gray-800 font-semibold" data-id="element-142">
                  base técnica sólida
                </span>{' '}
                y segura.
              </h2>
            </FadeIn>
          </div>

          <FadeIn delay={0.5} direction="left" className="relative" data-id="element-143">
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} className="relative z-10" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/fnUZ7jr4wbxAoswR7np48G/ngchjgj.png" alt="Pack Bases del Entrenamiento de Fuerza" className="w-full max-w-[600px] mx-auto drop-shadow-2xl" data-id="element-145" />
            </motion.div>
            {/* Image backdrop glow */}
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent blur-3xl -z-10 rounded-full" data-id="element-146" />
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-147">
          <div className="flex flex-col items-center gap-4 mt-10" data-id="element-148">
            <Button onClick={scrollToPricing} className="w-full sm:w-auto md:px-12 md:py-5 md:text-2xl" data-id="element-149">
              Ver oferta ahora
            </Button>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-150">
              <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-151" />
              <span data-id="element-152">Compra segura. Acceso inmediato.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}